import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";
import { PickersCalendarHeader } from "@mui/x-date-pickers";
export const StyledInputWrapper = styled("div")(({ style, size, fullWidth, error, disabled, readOnly }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ({
        ".MuiFormControl-root": {
            width: fullWidth ? "100%" : "auto",
        },
        ".MuiInputBase-root": {
            height: (style === null || style === void 0 ? void 0 : style.height) || (size === "large" && "40px") || (size === "medium" && "32px") || (size === "small" && "24px") || undefined,
            borderRadius: (_a = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _a !== void 0 ? _a : "6px",
            width: fullWidth ? "100%" : (_b = style === null || style === void 0 ? void 0 : style.width) !== null && _b !== void 0 ? _b : "16rem",
            backgroundColor: disabled || readOnly ? palette.grey010 : palette.white,
            padding: (_c = style === null || style === void 0 ? void 0 : style.padding) !== null && _c !== void 0 ? _c : "0 12px",
        },
        ".MuiInputBase-input": {
            height: "100% !important",
            width: "100%",
            overflow: "auto !important",
            border: "none",
            padding: "0",
            borderWidth: "0",
            color: (_d = style === null || style === void 0 ? void 0 : style.color) !== null && _d !== void 0 ? _d : ((readOnly && palette.grey060) || palette.grey090),
            ...((size === "large" && {
                ...typography["Content.Subtitle02"],
            }) ||
                (size === "medium" && {
                    ...typography === null || typography === void 0 ? void 0 : typography["Content.Subtitle03"],
                }) ||
                (size === "small" && {
                    ...typography === null || typography === void 0 ? void 0 : typography["Content.Subtitle04"],
                })),
            caretColor: (_e = style === null || style === void 0 ? void 0 : style.caretColor) !== null && _e !== void 0 ? _e : (error ? palette["negative-secondary"] : palette["maven-blue-dark"]),
            ...style,
        },
        ".Mui-disabled": {
            "-webkit-text-fill-color": palette.grey030,
        },
        ".MuiOutlinedInput-notchedOutline": {
            borderWidth: !(style === null || style === void 0 ? void 0 : style.border) ? (_f = style === null || style === void 0 ? void 0 : style.borderWidth) !== null && _f !== void 0 ? _f : "1px !important" : undefined,
            borderColor: !(style === null || style === void 0 ? void 0 : style.border)
                ? (_g = style === null || style === void 0 ? void 0 : style.borderColor) !== null && _g !== void 0 ? _g : ((disabled && `${palette.grey025} !important`) || (error && palette["negative-secondary"]) || palette.grey025)
                : undefined,
            border: style === null || style === void 0 ? void 0 : style.border,
        },
    });
});
// eslint-disable-next-line no-empty-pattern
export const StyledCalendarPaper = styled(Paper)(({}) => ({
    boxShadow: `0px 2px 16px 0px ${palette.black}29`,
    borderRadius: "6px",
    ".MuiList-root::after": {
        height: "0",
    },
    ".MuiPickersCalendarHeader-root": {
        margin: "20px 0 8px 0",
    },
    ".MuiDayCalendar-header": {
        borderBottom: `1px solid ${palette.grey020}`,
        margin: "0 16px",
    },
    ".MuiDayCalendar-weekDayLabel": {
        ...typography === null || typography === void 0 ? void 0 : typography["Content.Subtitle03"],
        color: palette.grey050,
        width: "30px",
        height: "30px",
        margin: "0 6px",
    },
    ".MuiPickersDay-root": {
        ...typography === null || typography === void 0 ? void 0 : typography["Content.Subtitle03"],
        width: "30px",
        height: "30px",
        margin: "0 6px",
        color: palette.grey070,
    },
    ".Mui-selected": {
        backgroundColor: `${palette["maven-blue-dark"]} !important`,
        color: palette.white,
    },
    ".MuiPickersDay-today": {
        border: `1px solid ${palette["maven-blue-dark"]} !important`,
        ":focus": {
            backgroundColor: palette.white,
        },
    },
    ".Mui-disabled": {
        color: `${palette.grey030} !important`,
    },
    ".MuiList-root": {
        width: "80px",
        scrollbarWidth: "thin",
        padding: "20px 0 8px",
    },
    ".MuiMenuItem-root": {
        borderRadius: "6px",
        padding: 0,
        width: "52px",
        minHeight: "30px",
        marginLeft: "10px",
    },
    ".MuiDigitalClock-root": {
        width: "160px",
    },
    ".MuiDigitalClock-item": {
        width: "128px",
        padding: "0 10px",
    },
    ".MuiDivider-vertical": {
        borderRight: `1px solid ${palette.grey020}`,
    },
    ".MuiDivider-root:not(.MuiDivider-vertical)": {
        borderBottom: `1px solid ${palette.grey020}`,
    },
    ".MuiMultiSectionDigitalClock-root": {
        borderBottom: `1px solid ${palette.grey020}`,
    },
    ".MuiMultiSectionDigitalClockSection-root:not(:first-of-type)": {
        borderLeft: `1px solid ${palette.grey020}`,
    },
    ".MuiMultiSectionDigitalClockSection-item": {
        marginBottom: "12px",
        ...typography["Content.Subtitle03"],
    },
    ".MuiPickersYear-yearButton": {
        width: "60px",
        height: "30px",
        color: palette.grey070,
        ...typography["Content.Subtitle03"],
        "&.Mui-selected": {
            color: palette.white,
        },
    },
    ".MuiDayCalendar-weekContainer": {
        margin: "4px 0",
    },
}));
// eslint-disable-next-line no-empty-pattern
export const StyledCalendarHeader = styled((PickersCalendarHeader))(({}) => ({
    position: "relative",
    ".MuiPickersArrowSwitcher-root": {
        width: 0,
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        margin: "auto",
        height: "30px",
        color: palette.grey070,
    },
    ".MuiIconButton-edgeEnd": {
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
    },
    ".MuiIconButton-edgeStart": {
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
    },
}));
//# sourceMappingURL=common.style.js.map